<template>
  <div class="poem">
    <transition name="fade">
      <div class="poem__share" v-if="showShareModal" @click="closeShare">
        <div class="vailentine-header__about-modal-close">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
              <g class="nc-icon-wrapper" fill="#111111">
                  <path d="M38 12.83L35.17 10 24 21.17 12.83 10 10 12.83 21.17 24 10 35.17 12.83 38 24 26.83 35.17 38 38 35.17 26.83 24z"></path>
              </g>
          </svg>
        </div>
        <button class="poem__share-button" @click.prevent="share('facebook')">
          <span class="poem__share-icon"><img src="/static/img/fb_icon.svg"></span>
          Share via Facebook
          <span class="poem__share-chevron"><img src="/static/img/chevron-right.svg"></span>
        </button>
        <button class="poem__share-button" @click.prevent="share('twitter')">
          <span class="poem__share-icon"><img src="/static/img/tw_icon.svg"></span>
          Share via Twitter
          <span class="poem__share-chevron"><img src="/static/img/chevron-right.svg"></span>
        </button>
        <a :href="getEmailLink" class="poem__share-button">
          <span class="poem__share-icon poem__share-icon--email"><img src="/static/img/em_icon.svg"></span>
          Share via Email
          <span class="poem__share-chevron"><img src="/static/img/chevron-right.svg"></span>
        </a>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="poem">
        <div class="poem__hearts">
          <heart :key="i" :size="heart.size" :start-left="heart.startLeft" :start-top="heart.startTop" :end-left="heart.endLeft" :end-top="heart.endTop" v-for="(heart, i) in hearts"></heart>
        </div>
        <div class="poem__inner">
          <div class="poem__verse">
            <div class="poem__verse-inner">
              <div class="poem__quote"><img src="/static/img/quotations.svg"></div>
              <h1 class="poem__to">{{name}}:</h1>
              <p v-html="poem"></p>
              <div class="row">
                <div class="col--sm-5 poem__signature-heart"><img src="/static/img/p_heart.svg"></div>
                <small class="col--sm-7 poem__signature">Yours for like ever,<br><span class="poem__author">{{author}}</span></small>
              </div>
            </div>
          </div>
          <div class="poem__footer">
            <button class="poem__cta poem__cta--restart" @click.prevent="restart">Start over</button>
            <button class="poem__cta poem__cta--share" @click.prevent="showShare">Share</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import domHelpers from '@/assets/js/dom'
import Heart from '@/components/Heart'
import queryString from 'query-string'
import router from '../router'

export default {
  name: 'Poem',

  components: {
    Heart
  },

  data () {
    return {
      author: 'Your lover',
      windowOptions: {
        width: 550,
        height: 450,
        menubar: 0,
        resizable: 'yes',
        toolbar: 0
      },
      hearts: [
        {
          endLeft: -20,
          endTop: -200,
          size: 100,
          startLeft: 20,
          startTop: 20
        },
        {
          endLeft: -340,
          endTop: -180,
          size: 80,
          startLeft: 50,
          startTop: 40
        },
        {
          endLeft: -60,
          endTop: -200,
          size: 60,
          startLeft: 60,
          startTop: 60
        },
        {
          endLeft: -380,
          endTop: -160,
          size: 40,
          startLeft: 110,
          startTop: 80
        },
        {
          endLeft: -300,
          endTop: -200,
          size: 20,
          startLeft: 100,
          startTop: 100
        },
        {
          endLeft: -320,
          endTop: -140,
          size: 140,
          startLeft: 110,
          startTop: 10
        },
        {
          endLeft: -140,
          endTop: -200,
          size: 120,
          startLeft: 30,
          startTop: 30
        },
        {
          endLeft: -360,
          endTop: -140,
          size: 100,
          startLeft: 100,
          startTop: 50
        },
        {
          endLeft: -180,
          endTop: -200,
          size: 80,
          startLeft: 70,
          startTop: 70
        },
        {
          endLeft: -300,
          endTop: -120,
          size: 60,
          startLeft: 100,
          startTop: 90
        }
      ],
      name: 'My love',
      poem: '',
      showShareModal: false,
      url: ''
    }
  },

  computed: {
    getEmailLink () {
      return `mailto:?subject=${this.getTitle()}&body=` +
          encodeURIComponent(this.getDescription()) +
          encodeURIComponent('\n\n') + this.url +
          encodeURIComponent(`\n\nWith love,\n${this.author}`)
    }
  },

  methods: {
    closeShare (e) {
      if (!domHelpers.getAncestorByClassName(e.target, 'poem__share-button')) {
        this.showShareModal = false
      }
    },

    getDescription () {
      return `Dear ${this.name},\n\nI wrote a poem for you with v*AI*lentine:`
    },

    getTitle () {
      return `A v*AI*lentine sonnet for ${this.name}`
    },

    getUrl (type) {
      switch (type) {
        case 'facebook':
          return `https://www.facebook.com/sharer.php?u=${this.url}`
        case 'twitter':
          return 'https://twitter.com/intent/tweet?text=' + this.getTitle() +
              '&url=' + this.url
      }
    },

    share (type) {
      const url = this.getUrl(type)
      const options = []

      for (const option in this.windowOptions) {
        options.push(`${option}=${this.windowOptions[option]}`)
      }

      window.open(url, 'sharer', options.join(','))
    },

    restart () {
      router.push({name: 'Questions'})
    },

    showShare () {
      this.showShareModal = true
    }
  },

  mounted () {
    this.url = window.location.href
    this.poemId = queryString.parse(location.search).poemId

    this.$http.get(`/api/hugs/v1/blush?poem_id=${this.poemId}`).then((response) => {
      return response.json()
    }).then((data) => {
      this.poem = data.poem || 'Tis better to be vile than vile esteem,<br><br>When not to be receives reproach of being,<br><br>And the just pleasure lost which is so deem<br><br>Not by our feeling but by others seeing:<br><br>For why should others false adulterate eyes<br><br>Give salutation to my sportive blood?'
      this.author = data.author || 'Your lover'
      this.name = data.name || 'My love'
    }, (response) => {
      this.poem = "Why lov'st thou that I have seen roses do not so; of their fair suBject, Blessing every book.<br><br>That Marie were when first I hallow'd thy fair flower is to the world that I before have heard them told.<br><br>Feeds on the finger of a former sight.<br><br>"
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/placeholders';
@import '../assets/sass/variables';

.poem {
  @extend %h5;

  background: $red-1 url('/static/img/r_sml_heart.svg') repeat-x 0 10px;
  color: $white;
  height: calc(100% - 70px);
  line-height: 28px;
  margin: 0;
  overflow: hidden;
  position: absolute;
  width: 100vw;
}

.poem__inner {
  display: flex;
  flex-direction: column;
  height: calc(100% - 35px);
  position: absolute;
  top: 35px;
  width: 100%;
}

.poem__quote {
  padding-top: 40px;
}

.poem__verse {
  flex: 1 1 auto;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.poem__verse-inner {
  margin: 0 auto;
  max-width: 480px;
  padding: 0 40px;
}

.poem__signature-heart {
  text-align: right;
}

.poem__signature {
  padding: 0 0 20px 20px;
  text-align: left;

  @include from-breakpoint(md) {
    padding-bottom: 64px;
  }
}

.poem__author {
  @extend %h4;

  margin: 0;
  text-align: left;
}

.poem__footer {
  align-items: center;
  background-color: $red-2;
  display: flex;
  flex: 0 1 125px;
  justify-content: center;
  min-height: 86px;
  padding: 0 5px;
}

.poem__cta {
  @extend %cta;

  font-size: 26px;
  margin: 0 5px;
  white-space: nowrap;

  &:hover,
  &:focus {
    color: $red-2;
    background-color: $white;
  }
}

.poem__to {
  @extend %h3;

  margin-top: 20px;
}

.poem__hearts {
  pointer-events: none;
}

.poem__share {
  align-items: center;
  background: rgba(218, 69, 83, .64);
  border-bottom: 1px solid $grey-3;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;

  @include from-breakpoint(md) {
    border-left: 1px solid $grey-3;
    border-right: 1px solid $grey-3;
    justify-content: center;
  }
}

.vailentine-header__about-modal-close {
  cursor: pointer;
  height: 32px;
  position: absolute;
  right: 40px;
  top: 24px;
  width: 32px;

  .nc-icon-wrapper {
    fill: $white;
  }

  @include from-breakpoint(md) {
    right: 32px;
    top: 32px;
  }
}

.poem__share-button {
  background: $white;
  border: 0;
  border-top: 1px solid $grey-3;
  color: $grey-5;
  cursor: pointer;
  display: block;
  font-family: $font-lato;
  font-size: 16px;
  letter-spacing: 0.025em;
  margin: 0;
  padding: 26px;
  position: relative;
  text-align: left;
  width: 100%;

  @include from-breakpoint(md) {
    max-width: 375px;
  }
}

.poem__share-icon,
.poem__share-chevron {
  display: inline-block;
}

.poem__share-icon {
  border: 2px solid $grey-3;
  border-radius: 100%;
  height: 40px;
  margin-right: 16px;
  padding: 10px 0 0;
  text-align: center;
  width: 40px;
}

.poem__share-icon--email {
  padding-top: 6px;
}

.poem__share-chevron {
  margin-top: -8px;
  position: absolute;
  right: 26px;
  top: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Poem.vue